<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M7.92495 13.3002H16.075C16.4416 13.3002 16.7541 13.171 17.0125 12.9127C17.2708 12.6544 17.4 12.3419 17.4 11.9752C17.4 11.6085 17.2708 11.296 17.0125 11.0377C16.7541 10.7794 16.4416 10.6502 16.075 10.6502H7.92495C7.55828 10.6502 7.24578 10.7794 6.98745 11.0377C6.72912 11.296 6.59995 11.6085 6.59995 11.9752C6.59995 12.3419 6.72912 12.6544 6.98745 12.9127C7.24578 13.171 7.55828 13.3002 7.92495 13.3002ZM12 22.8002C10.506 22.8002 9.10195 22.5167 7.78795 21.9497C6.47395 21.3827 5.33095 20.6132 4.35895 19.6412C3.38695 18.6692 2.61745 17.5262 2.05045 16.2122C1.48345 14.8982 1.19995 13.4942 1.19995 12.0002C1.19995 10.5019 1.48395 9.09386 2.05195 7.7762C2.61995 6.45836 3.39078 5.31211 4.36445 4.33745C5.33812 3.36261 6.48112 2.59603 7.79345 2.0377C9.10578 1.47936 10.508 1.2002 12 1.2002C13.4981 1.2002 14.906 1.47936 16.2235 2.0377C17.5411 2.59603 18.6875 3.3627 19.6625 4.3377C20.6375 5.3127 21.4041 6.4592 21.9625 7.7772C22.5208 9.09536 22.8 10.5037 22.8 12.0022C22.8 13.5009 22.5208 14.9044 21.9625 16.2127C21.4041 17.521 20.6375 18.662 19.6627 19.6357C18.688 20.6094 17.5418 21.3802 16.224 21.9482C14.9063 22.5162 13.4983 22.8002 12 22.8002Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "st-icon",
  props: {
    color: {
      type: String,
      default: "#6D202B",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
